"use client";

import dynamic from "next/dynamic";
import type { KentTown } from "@/lib/locations";

const DeliveryMap = dynamic(() => import("./delivery-map"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-[400px] md:h-[500px] rounded-xl border border-[var(--color-border)] bg-[var(--color-muted)] flex items-center justify-center">
      <p className="text-[var(--color-secondary)] text-sm">Loading map…</p>
    </div>
  ),
});

export function DeliveryMapClient({ towns }: { towns: KentTown[] }) {
  return <DeliveryMap towns={towns} />;
}
